var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('router-link',{attrs:{"to":"/home"}},[_c('img',{attrs:{"src":require("../assets/images/logo.svg")}}),_vm._v(" "),_c('p',[_vm._v("any one can cook")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7750de2e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hello.vue
// module id = 74
// module chunks = 0